import currency from 'currency.js'

/**
 * @param  {String} str
 */
export const formatDate = (str) => {
  const date = new Date(str)
  let year = date.getUTCFullYear()
  let month = date.getUTCMonth()+1
  let day = date.getUTCDate()

  if ( day < 10 ) { day = '0' + day}
  if ( month < 10 ) { month = '0' + month }

  const dateFormat = `${day}/${month}/${year}`

  return dateFormat
}

/**
 * @param  {String} str
 */
export const formatDateDayMonth = (str) => {
  const date = new Date(str)
  let month = date.getMonth()+1
  let day = date.getUTCDate()

  if ( day < 10 ) { day = '0' + day}
  if ( month < 10 ) { month = '0' + month }

  const dateFormat = `${day}/${month}`

  return dateFormat
}


/**
 * @param  {Number} value
 */
export const formatPrice = (value) => {
  let val = (value/100).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

/**
 * @param  {Number} value
 */
export const formatPriceSlim = (value) => {
  let val = (value/100).toFixed(2)
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}


/**
 * @param  {String} str
 * @param  {Number} index=-2
 * @param  {String} replace='.'
 */
export const splicePrice = (str, index = -2, replace = '.') => {
  if (!str) { return }
  const _str = toString(str)
  const _i = index < 0 ? _str.length + index : index
  const _number = `${_str.substring(0, _i)}${replace}${_str.substring(_i, _str.length)}`
  return parseFloat(_number)
}


/**
 * @param  {Number} number
 * @param  {Object} currencySettings={}
 */
export const currencyFormat = (number, currencySettings = {}) => {
  const _settings = {
    ...{
      symbol: '',
      separator: '.',
      decimal: ',',
      precision: 2
    },
    ...currencySettings
  }

  const _number = splicePrice(number, -2, '.')
  // return i18n.n(_number, 'currency') // format currency using vue-i18n
  return currency(_number, _settings).format(true) // format currency using currency.js
}

export const tenantName = window.location.host.split('.')[0]
